<template>
  <v-row>
    <!-- header -->
    <mini-header title="Detalle de ventas diarias" :dense="true" :breadcrumbs="breadcrumbs" :hiddenTab="true" />
    <!-- end header -->
    <v-container style="min-height: 75vh;">
      <v-row class="fill-height" align="center" justify="center">
        <v-col cols="8" class="px-0 mx-auto" style="min-width:580px">
          <v-empty-state type="sire" id="sales-report" :height="200" customClass="mt-8" :hiddenDescription="false" :isFree="true" title="Selecciona el rango de fechas de creación para los documentos que deseas descargar" description="Puedes seleccionar un período de hasta 31 días">
            <template v-slot:actions>
              <v-row class="mt-5" align="center" justify="center" no-gutters>
                <div class="mx-2 pa-0 text-left" style="width: 175px;">
                  <span class="d-block grey-700--text body-2">Desde</span>
                  <v-menu v-model="startDateMenu" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition" max-width="280" z-index="1000">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="startDate" v-bind="attrs" v-on="on" append-icon="mdi-calendar-blank" placeholder="dd-mm-aaaa" outlined single-line dense readonly hide-details />
                    </template>
                    <v-date-picker v-model="startDate" @input="startDateMenu=false" :max="maxDate" no-title :first-day-of-week="1" type="date" locale="es" width="270" color="blue-500">
                      <v-row class="pt-0 mb-1 px-5">
                        <v-btn class="body-1" :ripple="false" text color="blue-500" @click="() => { startDate=null; startDateMenu=false }">Limpiar</v-btn>
                      </v-row>
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="mx-2 pa-0 text-left" style="width: 175px;">
                  <span class="d-block grey-700--text body-2">Hasta</span>
                  <v-menu v-model="endDateMenu" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition" max-width="280" z-index="1000">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="endDate" v-bind="attrs" v-on="on" append-icon="mdi-calendar-blank" placeholder="dd-mm-aaaa" outlined single-line dense readonly hide-details :disabled="!startDate" />
                    </template>
                    <v-date-picker v-model="endDate" @input="endDateMenu=false" :min="startDate" :max="maxDate" no-title :first-day-of-week="1" type="date" locale="es" width="270" color="blue-500">
                      <v-row class="mb-1 px-5">
                        <v-btn class="body-1" :ripple="false" text color="blue-500" @click="() => { endDate=null; endDateMenu=false }">Limpiar</v-btn>
                      </v-row>
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="mx-2 pa-0 pt-4">
                  <v-btn @click="createExport" color="blue-500" :loading="loading" :disabled="!startDate || !endDate" :ripple="false" :width="153">Descargar</v-btn>
                </div>
              </v-row>
            </template>
          </v-empty-state>
          <v-col class="text-center">
            <!-- alert -->
            <v-alert class="inf-alert-blue blue-500--text rounded-md mt-2 mx-auto" :height="56" :width="540" dense text>
              <div class="d-flex align-center pa-0 my-0">
                <v-icon class="pt-1" color="blue-500" size="22">mdi-information-outline</v-icon>
                <div class="ml-4 mt-1 d-flex align-center text-left">
                  <span class="body-2">Esta acción
                    <span class="font-weight-bold">podría tardar varios minutos</span> en completarse. No cierres el navegador hasta completar la descarga.
                  </span>
                </div>
              </div>
            </v-alert>
            <!-- end alert -->
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>
<script>
import moment from 'moment'
import { saveAs } from 'file-saver'
import MiniHeader from '@/components/commons/MiniHeader'
import VEmptyState from '@/components/commons/VEmptyState'

const MAX_RANGE_DAYS = 31

export default {
  components: {
    MiniHeader,
    VEmptyState
  },
  data () {
    return {
      loading: false,
      startDateMenu: false,
      endDateMenu: false,
      startDate: null,
      endDate: null,
      breadcrumbs: {
        main: 'Emisión',
        children: [
          {
            text: 'Reportes',
            route: 'ReportsList',
            text1: 'Detalle de ventas diarias'
          }
        ]
      }
    }
  },
  computed: {
    maxDate () {
      return moment().format('YYYY-MM-DD')
    }
  },
  watch: {
    startDate () {
      this.endDate = null
    }
  },
  methods: {
    createExport () {
      if (!this.startDate || !this.endDate) return
      const days = moment(this.endDate).diff(moment(this.startDate), 'days') + 1
      if (days > MAX_RANGE_DAYS) {
        this.$dialog.message.error('El rango máximo permitido es de 31 días', { timeout: 6000 })
        return
      }
      this.loading = true
      this.$store.dispatch('accounts/LIST', {
        resource: 'documents/sales-report',
        query: {
          // backend expects snake_case params (start_date/end_date), not camelCase
          start_date: this.startDate,
          end_date: this.endDate
        },
        responseType: 'blob',
        loader: false
      })
      .then((response) => {
        saveAs(new Blob([response.data], { type: response.headers['content-type'] || 'application/zip' }), this.getFilename(response.headers['content-disposition']))
      })
      .catch((error) => {
        const status = error?.response?.status
        let message = 'No fue posible generar el reporte en este momento. Intenta nuevamente más tarde.'
        if (status === 400) message = 'Revisa el rango de fechas seleccionado e intenta nuevamente.'
        else if (status === 404) message = 'No se encontraron ventas para el rango de fechas seleccionado.'
        this.$dialog.message.error(message, { timeout: 8000 })
      })
      .finally(() => {
        this.loading = false
      })
    },
    getFilename (contentDisposition) {
      let filename = 'detalle-ventas-diarias.zip'
      if (contentDisposition) {
        const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
        if (match && match[1]) filename = match[1].replace(/['"]/g, '')
      }
      return filename
    }
  }
}
</script>
